const ForgotPasswordResetSchema = {
  type: "object",
  properties: {
    newPassword: {
      type: "string",
      title: "New Password",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Password",
    },
    confirmPassword: {
      type: "string",
      title: "Confirm Password",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Password",
    },
  },
};

export default ForgotPasswordResetSchema;
